<template lang="html">
  <div v-show="show.msg" class="main">
    <div class="name">
      <span class="word">{{message.Sl223}}</span>
      <span class="cntrol">
        <i class="material-icons" @click="onClosea">
          close
        </i>
      </span>
    </div>
    <div class="box"
      v-loading="boxLoading"
      :element-loading-text="boxLoadingText"
    >
      <div class="cell">
        <span class="cell-name">
          Request to send
        </span>
         <el-select
          v-model="usersValue"
          filterable
          style="width:360px;margin:0 auto"
          :placeholder="message.Pl157"
          @click = "userList()"
         >
          <el-option
            v-for="item in users"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span class="user-name">{{ item.label }}</span>
            <span class="user-email" :title="item.email">{{ item.email }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="cell">
        <span class="cell-name">
          {{message.Al121}}
        </span>
      </div>
      <div class="cell" style="border-bottm:1px solid #ccc">
        <span class="cell-name">
          {{message.Al124}}
        </span>
        <el-input
        type="textarea"
        v-model="notes"
        :placeholder="message.Al125"
        :autosize="{ minRows: 12, maxRows: 12}"
        style="width:360px;margin: 0 auto;"
        maxlength="255"
        >
        </el-input>
      </div>
      <el-button type="primary" :disabled="sendDisabled" @click="sentMsg()" class="submit" size="small">{{message.Sl226}}</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      show: 'show',
      size: 'size',
      account: 'account'
    }),
    sendDisabled: function () {
      if (
        !this.usersValue ||
        this.notes === ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'show.msg': function (val) {
      if (val) {
        this.userList()
      }
    }
  },
  data () {
    return {
      message: {
        Al118: this.$lang.ui.app.l118,
        Al119: this.$lang.ui.app.l119,
        Pl157: this.$lang.ui.prompt.l157,
        Al121: this.$lang.ui.app.l121,
        Al122: this.$lang.ui.app.l122,
        Al123: this.$lang.ui.app.l123,
        Al124: this.$lang.ui.app.l124,
        Al125: this.$lang.ui.app.l125,
        Al126: this.$lang.ui.app.l126,
        Al132: this.$lang.ui.app.l132,
        Al137: this.$lang.ui.app.l137,
        Al157: this.$lang.ui.app.l157,
        Al158: this.$lang.ui.app.l158,
        Al159: this.$lang.ui.app.l159,
        Sl223: this.$lang.ui.system.l223,
        Sl226: this.$lang.ui.system.l226
      },
      showChoose: false,
      showChooseCell: false,
      boxPosition: {
        left: 0,
        top: 0
      },
      boxLoading: false,
      boxLoadingText: this.$lang.ui.app.l127,
      uploadIcon: true,
      loading: false,
      users: [],
      email: '',
      usersValue: null,
      notes: ''
    }
  },
  mounted () {
  },
  methods: {
    userList () {
      var id = localStorage.getItem('projectId')
      this.$http.get('/cydex/api/v1/projects/' + id + '/members', { params: {
        'sort': 'name'
      } })
        .then(response => {
          this.users = []
          for (var i = 0; i < response.data.members.length; i++) {
            if (response.data.members[i].user_info.is_black_user === 0) {
              this.users.push({
                label: response.data.members[i].user_info.name,
                value: response.data.members[i].user_info.id,
                email: response.data.members[i].user_info.email
              })
            }
          }
        })
    },
    onClosea () {
      this.$store.dispatch('showMsg', false)
      this.users = []
      this.usersValue = null
      this.notes = ''
      this.boxLoading = false
      this.boxLoadingText = ''
      this.uploadIcon = true
      this.loading = false
    },
    sentMsg () {
      var data = {
        user_list: [this.usersValue],
        description: this.notes,
        project_id: localStorage.getItem('projectId')
      }
      this.$api.requestToSend(data, response => {
        this.$message({
          message: this.$lang.ui.notice.l136,
          type: 'success'
        })
        this.$store.dispatch('showMsg', false)
      })
      this.usersValue = null
      this.notes = ''
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  z-index: 10000;
  position: fixed;
  width: 460px;
  /*left: 50%;
  top: 15%;
  margin-left: -230px;*/
  background-color: #fff;
  overflow: hidden;
  margin-left: -230px;
  left: 50%;
  top: 15%;
  height: auto;
  border-radius: 3px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.name {
  font-size: 14px;
  padding: 0 15px;
  text-align: left;
  color: #fff;
  height: 35px;
  line-height: 35px;
  /*background-color: #d9534f;*/
  background-color: #007bc5;
}
.upload-body {
  display: none;
  position: absolute;
  border: 1px solid #d8dce5;
  left: -2px;
  top: 16px;
  background-color: #fff;
  border-radius: 4px;
  width: 110px;
}
.upload-cell {
  display: inline-block;
  color: #5a5e66;
  padding: 4px 8px;
  width: 100%;
}
.upload-cell:hover {
  color: #212121;
}
.upload-choose:hover .upload-body {
  display: block;
}
.upload-choose {
  position: absolute;
  display: block;
  cursor: pointer;
  top: 8px;
  color: #007bc5;
  z-index: 3;
  left: 50px;
}
.cntrol i {
  float: right !important;
  cursor: pointer;
  text-align: center;
}
.name .word {
  display: inline-block;
  padding-left: 8px;
}
.main.min {
  left: auto;
  top: auto;
  right: 10px;
  width: 285px;
  bottom: 30px;
  height: 35px;
}
.main.min .box {
  display: none;
}
.name i {
  margin-top: 5px;
  float: left;
}
.box {
  overflow: hidden;
  width: 100%;
  padding: 15px;
}
.user-name {
  float: left;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-email {
  float: right;
  color: #8492a6;
  width: 140px;
  text-align: right;
  font-size: 12px;
  padding-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell {
  display: flex;
  width: 100%;
  padding: 4px 1px;
  /*border-bottom: 1px solid #ccc;*/
}
.cell.file {
  position: relative;
}
.cell-name {
  display: none;
  float: left;
  font-size: 14px;
  width: 60px;
  font-weight: 600;
  padding-left: 8px;
  text-align: left;
  line-height: 35px;
}
.file  .cell-name {
  padding-top: 6px;
  line-height: 22px;
}
.cell-input {
  height: 35px;
  width: 360px;
  margin: 0 auto;
  border: 0;
  font-size: 16px;
}
textarea {
  flex-grow: 1;
  margin: 0 auto;
  height: 100px;
  width: 362px;
  max-width: 362px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.submit {
  float: right;
  margin-top: 10px;
  margin-bottom: 15px;
}
.upload {
  position: relative;
  margin: 0 auto;
  width: 360px;
  height: 180px;
  text-align: center;
  border: 1px dashed #ccc;
  border-radius: 12px;
}
.fileList {
  position: absolute;
  top: 14px;
  left: 12px;
  right: 12px;
  bottom: 4px;
  overflow-y: auto;
}
.el-upload-list__item-name {
  text-align: left;
}
.icon-folder {
  font-size: 15px;
  font-weight: 600;
  height: 100%;
  color: #97a8be;
  padding-left: 1px;
  margin-right: 6px;
}
.el-upload-list__item-name:hover .icon-folder {
  color: #97a8be;
}
.el-message__group {
  color: #212121 !important;
}
</style>
